import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  text-align: center;
  background: #f7fafc;
`;

const ErrorCode = styled.h1`
  font-size: 6rem;
  margin: 0;
  color: #667eea;
  font-weight: bold;
`;

const ErrorTitle = styled.h2`
  font-size: 2rem;
  margin: 1rem 0;
  color: #2d3748;
`;

const ErrorMessage = styled.p`
  font-size: 1.125rem;
  color: #718096;
  margin: 1rem 0 2rem;
  max-width: 500px;
`;

const HomeLink = styled(Link)`
  padding: 0.75rem 1.5rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-weight: 500;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;

const StackTrace = styled.pre`
  margin-top: 2rem;
  padding: 1rem;
  background: #1a202c;
  color: #e2e8f0;
  border-radius: 4px;
  font-size: 0.875rem;
  text-align: left;
  overflow-x: auto;
  max-width: 800px;
`;

export default function ErrorBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    return (
      <ErrorContainer>
        <ErrorCode>{error.status}</ErrorCode>
        <ErrorTitle>{error.statusText}</ErrorTitle>
        <ErrorMessage>
          {error.data?.message || "Sorry, an unexpected error has occurred."}
        </ErrorMessage>
        <HomeLink to="/">Go back home</HomeLink>
      </ErrorContainer>
    );
  }

  const errorMessage = error instanceof Error ? error.message : "Unknown error";
  const errorStack = error instanceof Error ? error.stack : null;

  return (
    <ErrorContainer>
      <ErrorCode>Error</ErrorCode>
      <ErrorTitle>Oops! Something went wrong</ErrorTitle>
      <ErrorMessage>{errorMessage}</ErrorMessage>
      <HomeLink to="/">Go back home</HomeLink>
      { errorStack && (
        <StackTrace>{errorStack}</StackTrace>
      )}
    </ErrorContainer>
  );
}
